export { default } from './es/icons/YasuoTwoTone';